export const PLAN_LABEL = {
  studio: "Studio",
  professional: "Professional",
  scale: "Scale",
  enterprise: "Enterprise",
};

export const STAGE_LABEL = {
  lead: "Lead",
  enriched: "Enriched",
  sequenced: "Sequenced",
  replied: "Replied",
  meeting_booked: "Meeting Booked",
  qualified: "Qualified",
  proposal: "Proposal",
  won: "Won",
  lost: "Lost",
};

export const REPLY_LABEL = {
  interested: { label: "Interested", color: "text-emerald-500 bg-emerald-500/10" },
  meeting: { label: "Meeting", color: "text-amber-500 bg-amber-500/10" },
  objection: { label: "Objection", color: "text-rose-500 bg-rose-500/10" },
  ooo: { label: "Out of Office", color: "text-sky-500 bg-sky-500/10" },
  referral: { label: "Referral", color: "text-violet-400 bg-violet-500/10" },
  unsubscribe: { label: "Unsubscribe", color: "text-muted-foreground bg-muted" },
};
